export default "<div class=\"font-weight-bold text-center text-danger\" *ngIf=\"error\">\n    {{error | translate}}\n</div>\n"